var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArchive = function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "archive_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#archive_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 10a.97.97 0 0 0-.713.287A.97.97 0 0 0 11 11v3.2l-.9-.9a.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275.95.95 0 0 0-.275.7q0 .425.275.7l2.6 2.6q.3.3.7.3t.7-.3l2.6-2.6a.95.95 0 0 0 .275-.7.95.95 0 0 0-.275-.7.95.95 0 0 0-.7-.275.95.95 0 0 0-.7.275l-.9.9V11a.97.97 0 0 0-.287-.713A.97.97 0 0 0 12 10M5 8v11h14V8zm0 13q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V6.525q0-.35.112-.675.113-.325.338-.6L4.7 3.725q.274-.35.688-.538Q5.8 3 6.25 3h11.5q.45 0 .863.188.412.187.687.537l1.25 1.525q.225.274.337.6t.113.675V19q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zm.4-15h13.2l-.85-1H6.25z"
  }))));
};
export default SvgArchive;